var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-hidden"},[_c('div',{ref:"pluginstoremodal",staticClass:"pluginstore-modal modal",class:'step-' + _vm.modalStep,attrs:{"id":"pluginstore-modal"}},[(_vm.modalStep === 'cart')?_c('cart',{on:{"continue-shopping":function($event){return _vm.$root.closeModal()}}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }